module.exports = __webpack_public_path__ + "img/collect_icon_02.ac2a085e.png";